import {
  Drawer as MuiDrawer,
  DrawerProps as MuiDrawerProps,
  DrawerClasses,
} from "@mui/material";
import React from "react";
import { withDisplayName } from "../../utils/displayName";

export { DrawerClasses };

export type DrawerProps = Omit<MuiDrawerProps, "anchor" | "variant">;

export const Drawer = (props: DrawerProps) => {
  return (
    <MuiDrawer
      /* eslint-disable-next-line i18next/no-literal-string */
      anchor="right"
      /* eslint-disable-next-line i18next/no-literal-string */
      variant="temporary"
      {...props}
    />
  );
};
withDisplayName(Drawer, "Drawer");
